import React from 'react';
import RegionalContainer from '../components/regionalcontainer';

export default (props) => <RegionalContainer {...props} />;
